<div class="table-view mbtm-30">
  <!-- Table starts -->
  <p-table
    #dt
    styleClass="kuba-balanced-table"
    [value]="kubaControlList"
    [rows]="10"
    [paginator]="true"
    alwaysShow="false"
    [pageLinks]="3"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
    [rowsPerPageOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
  >
    <!-- Caption -->
    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix">
        <div class="table-options">
          <div class="pull-right">
            <kuba-export
              [reportData]="dt.filteredValue || dt.value"
              [additionalData]="additionalData"
            ></kuba-export>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Title" style="width: 28%">
          {{ "OBJECT_NAME" | translate }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="ObjectType" style="width: 16%">
          {{ "TYPE_OF_OBJECT" | translate }}
        </th>
        <th pSortableColumn="CreatorName" style="width: 18%">
          {{ "CREATED_BY" | translate }}
        </th>
        <th pSortableColumn="CreatedOn" style="width: 10rem">
          {{ "CREATED_ON" | translate }}
        </th>
        <th pSortableColumn="Status" style="width: 8rem">
          {{ "STATUS" | translate }} <p-sortIcon field="Status"></p-sortIcon>
        </th>
        <th style="width: 10rem">{{ "DEVIATIONS_IN_FOLLOWUP" | translate }}</th>
        <th *ngIf="isAdministrateKc" width="90px">
          {{ "OPTIONS" | translate }}
        </th>
      </tr>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            (input)="dt.filter($event.target.value, 'Title', 'contains')"
            placeholder=""
            class="p-column-filter"
          />
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th>
          <input
            pInputText
            type="text"
            (input)="
              dt.filter($any($event.target)?.value, 'Status', 'contains')
            "
            placeholder=""
            class="p-column-filter"
          />
        </th>
        <th></th>
        <th *ngIf="isAdministrateKc"></th>
      </tr>
    </ng-template>
    <!-- Body Content -->
    <ng-template pTemplate="body" let-kc>
      <tr>
        <td>
          <a
            [routerLink]="['./../../details', kc.Id]"
            pTooltip="{{ kc.Title }}"
            tooltipPosition="top"
            [queryParams]="{ Title: kc.Title }"
            >{{ kc.Title }}</a
          >
        </td>
        <td>
          <span>{{ kc.ObjectType }}</span>
        </td>
        <td>
          <span>{{ kc.CreatorName }}</span>
        </td>
        <td>
          <span>{{ kc.CreatedOn | date: "MM/dd/yyyy" }}</span>
        </td>
        <td>
          <span translate>{{ kc.Status == 1 ? "ACTIVE" : "INACTIVE" }}</span>
        </td>
        <td>
          <input
            type="checkbox"
            [disabled]="true"
            [(ngModel)]="kc.ShowDeviation"
          />
        </td>
        <td class="col-button" *ngIf="isAdministrateKc">
          <a
            [routerLink]="['./../../edit', kc.Id]"
            
            title="{{ 'EDIT' | translate }}" [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"><i class="pi pi-pencil"></i></a>
          <button
            type="button"
            (click)="deleteFoodSafety(kc['Id'])"
            title="{{ 'DELETE' | translate }}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <!-- Empty message -->
    <ng-template pTemplate="emptymessage" *ngIf="isAdministrateKc" let-columns>
      <tr>
        <td colspan="7">
          {{ "NO_RECORDS_FOUND" | translate }}
        </td>
      </tr>
    </ng-template>
    <!-- Empty message -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="6">
          {{ "NO_RECORDS_FOUND" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!-- Table Ends-->
</div>
<router-outlet></router-outlet>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
